export const Quote = ({ children }: { children: React.ReactNode }) => (
  <blockquote style={{
    color: '#555',
    fontSize: '18px',
    fontWeight: '300',
    margin: '20px 5px 15px',
    textAlign: 'center',
  }}>
    {children}
  </blockquote>
);